import isEqual from 'lodash/isEqual';
import { createSelector } from 'reselect';

import { AppState } from 'bootstrap.store';

import { MessengerSettingsReducerState } from './messengerSettings.reducer';
import { KnowledgeState } from './messengerSettings.types';

const isPristine = (state: MessengerSettingsReducerState): boolean =>
  isEqual(state.elevioIntegration, state.pristineElevioIntegration);

const selectSettings = (state: AppState): MessengerSettingsReducerState =>
  state.messengerSettings;

const knowledgeStateSelector = (
  state: MessengerSettingsReducerState,
): KnowledgeState => ({
  ...state,
  isPristine: isPristine(state),
});

export const selectKnowledgeState = createSelector(
  [selectSettings],
  knowledgeStateSelector,
);
